







import { Component, Emit, Vue } from 'vue-property-decorator'
import DeckForm from './deck-form.vue'
import { defaultDeck, randomId } from '../lib'

@Component({
  components: { DeckForm }
})
export default class NewDeckForm extends Vue {
  private newDeck: Deck = defaultDeck()

  @Emit('save')
  private saveDeck (deck: Deck) {
    deck.id = randomId() // just to make sure
    this.$storage.saveDeck(deck)
  }
}
